const RAW_API_URL = (import.meta.env.VITE_API_URL || '/api').trim().replace(/\/+$/, '');

const ensureApiSuffix = (base: string) => (base.endsWith('/api') ? base : `${base}/api`);

export const API_BASE_URL = ensureApiSuffix(RAW_API_URL || '/api');
